import { ConsignmentRequestListPage } from "@/features/consignment-request/pages/ConsignmentRequestListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-request/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: {
					operator: "OR",
					permissions: [
						"consignment_registration.view",
						"consignment_registration.view_all",
					],
				},
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentRequestListPage,
});
